<div class="text-center">
    <div class="selectMonth"><b>Select Month</b></div>
    <div class="relative">
        <ng-select #monthSelect [items]="monthList" bindLabel="month_of_attendance" [multiple]="false"
            [closeOnSelect]="true" [clearable]="true" [loading]="monthLoading" [typeahead]="monthInput$"
            typeToSearchText="Employee Name" [virtualScroll]="true" [(ngModel)]="selectedMonth"></ng-select>
        <i class="fa fa-search" style="right: 40px !important;"></i>
    </div>
</div>